import { useCallback, useSyncExternalStore } from 'react';

// Whether a CSS media query matches, kept current as the window is resized or
// a phone is turned. For layouts that differ by screen size in what they
// render, not only in how it is styled.
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    const list = window.matchMedia(query);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
}
